
<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="consulta in consultas"
        :key="consulta.id"
      >
        <v-card outlined>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>{{$Datetime.fromSQL(consulta.fecha_con).setLocale('es').toLocaleString($Datetime.DATETIME_MED)}}</v-list-item-subtitle>
                <v-list-item-title>Motivo: {{consulta.motivo_con}}</v-list-item-title>
                <v-list-item-subtitle class="nowrap">
                  Médico: {{consulta.medico}}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :to="`/consulta/${paciente}/${consulta.id}`"
                >
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
export default {
  name: "PacientesDetalleConsultas",
  mixins: [forms],
  props: {
    id: [String, Number],
  },
  data() {
    return {
      paciente: null,
      consultas: [],
    };
  },
  methods: {
    _getConsultas() {
      if (this.id) {
        this._getThings("consultas/" + this.id, "consultas");
      }
    },
  },
  created() {
    this.paciente = this.id;
    this._getConsultas();
  },
  watch: {
    id() {
      this.paciente = this.id;
      this._getConsultas();
    },
  },
};
</script>

